import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import PdfReducer from "./pdfSummarization/reducer";
import ChatBotReducer from "./chatBot/reducer";
import InvoiceReducer from "./invoiceScanner/reducer";
import CallLogReducer from "./callLog/reducer";

//Client
import ClientReducer from "./clients/reducer";


// API Key
import APIKeyReducer from "./apiKey/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    APIKey: APIKeyReducer,
    ClientData:ClientReducer,
    Pdf: PdfReducer,
    ChatBot: ChatBotReducer,
    Invoice: InvoiceReducer,
    CallLog: CallLogReducer,
});

export default rootReducer;
